import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { styled, Box } from "@mui/system";
import ModalUnstyled from "@mui/base/ModalUnstyled";
import { SPLToken } from "../../interfaces";
import { getAllMints, usedMints } from "../../utils/spl-tokens";
import { solanaConstantsStore } from "../../state/flowchart-store";
import { useStore } from "react-stores";
import { TokenInfo } from "@solana/spl-token-registry";
import TokenLine from "./TokenLine";

const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Backdrop = styled("div")`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = {
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  p: 2,
  px: 4,
  pb: 3,
};

type SelectFn = (token: TokenInfo) => void | Promise<void>;

export default function TokenAccountChooser(props: {
  buttonText?: string;
  includedMints?: string[];
  onSelect: SelectFn;
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <button type="button" className="controls2" onClick={handleOpen}>
        {props.buttonText ?? "Choose Token"}
      </button>
      <StyledModal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={open}
        onClose={handleClose}
        BackdropComponent={Backdrop}
      >
        <Box sx={style}>
          <h2 id="unstyled-modal-title">Select Mint</h2>
          <div>
            <TokenDropDown
              includedMints={props.includedMints}
              onSelect={props.onSelect}
            />
          </div>
        </Box>
      </StyledModal>
    </div>
  );
}

interface TokenDropdownOpts {
  label: string;
  token: TokenInfo;
}

const TokenDropDown = (props: {
  onSelect?: SelectFn;
  includedMints?: string[];
}) => {
  const { onSelect } = props;
  const [inputValue, setInputValue] = React.useState("");
  const [label, setLabel] = React.useState<null | TokenDropdownOpts>(null);
  const [options, setOptions] = React.useState<TokenDropdownOpts[] | null>(
    null
  );

  const getOptions = (tokList: TokenInfo[]) => {
    const toFilterBy = props.includedMints ?? usedMints;
    const tokListFiltered = tokList.filter((t) =>
      toFilterBy.includes(t.address)
    );
    return tokListFiltered.map((tok) => {
      return {
        label: tok.symbol,
        token: tok,
      };
    });
  };

  React.useEffect(() => {
    if (label && onSelect) onSelect(label?.token);
  }, [label]);

  React.useMemo(() => {
    getAllMints().then((toks) => {
      const opts = getOptions(toks);
      setOptions(opts);
    });
  }, []);

  return (
    <div>
      {options ? (
        <Autocomplete
          value={label}
          inputValue={inputValue}
          onChange={(event, newValue) => {
            setLabel(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          id="combo-box-demo"
          getOptionLabel={(opts) => opts.label}
          isOptionEqualToValue={(opt, val) => opt.label === val.label}
          options={options}
          sx={{ width: 300, backgroundColor: "white" }}
          renderOption={(params, opt) => (
            <>
              <TokenLine
                tok={opt.token}
                onClick={(tok) => {
                  setLabel({
                    label: tok.symbol,
                    token: tok,
                  });
                }}
              />
            </>
          )}
          // renderTags={(opts) => <TokenLine tok={opts[0].token} />}
          renderInput={(params) => (
            <>
              {/* {params} */}
              <TextField {...params} label="Mint" />
            </>
          )}
        />
      ) : (
        <div>loading...</div>
      )}
    </div>
  );
};
